import { useTranslation } from '../presentation/common/useTranslation.js';

import { Globe } from 'lucide-react';
import { changeLanguage } from '../i18n';

export default function LanguageSwitcher({ variant = 'compact' }) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language ? i18n.language.substring(0, 2) : 'de';

  const toggleLanguage = (lang) => {
    changeLanguage(lang);
  };

  if (variant === 'full') {
    return (
      <div className="flex gap-2">
        <button
          type="button"
          aria-pressed={currentLang === 'de'} onClick={() => toggleLanguage('de')}
          className={`world-button px-3 py-2 border text-sm flex items-center justify-center gap-2 transition-colors ${
            currentLang === 'de'
              ? 'border-amber-500 text-amber-300'
              : 'border-zinc-700 text-zinc-400 hover:text-zinc-200'
          }`}
        >
          <span>🇩🇪 Deutsch</span>
        </button>
        <button
          type="button"
          aria-pressed={currentLang === 'en'} onClick={() => toggleLanguage('en')}
          className={`world-button px-3 py-2 border text-sm flex items-center justify-center gap-2 transition-colors ${
            currentLang === 'en'
              ? 'border-amber-500 text-amber-300'
              : 'border-zinc-700 text-zinc-400 hover:text-zinc-200'
          }`}
        >
          <span>🇬🇧 English</span>
        </button>
      </div>
    );
  }

  // Compact variant for headers / topbars
  return (
    <div className="world-language inline-flex items-center p-1 text-xs">
      <button
        type="button"
        aria-pressed={currentLang === 'de'} onClick={() => toggleLanguage('de')}
        className={`px-2 py-1 transition-colors font-bold ${
          currentLang === 'de'
            ? 'bg-zinc-800 text-zinc-100'
            : 'text-zinc-500 hover:text-zinc-300'
        }`}
        title="Deutsch"
      >
        DE
      </button>
      <div className="h-3 w-px bg-zinc-800" />
      <button
        type="button"
        aria-pressed={currentLang === 'en'} onClick={() => toggleLanguage('en')}
        className={`px-2 py-1 transition-colors font-bold ${
          currentLang === 'en'
            ? 'bg-zinc-800 text-zinc-100'
            : 'text-zinc-500 hover:text-zinc-300'
        }`}
        title="English"
      >
        EN
      </button>
    </div>
  );
}
